import { defineCollection } from "@rebasepro/cms-types";
import { catalogueFile } from "../words";

// The song catalogue as the files games deal from (songbuzz_catalogue_files): songs.json and one file per mix and
// country, gzipped, rebuilt every three hours by the catalogue-files cron. The bytes stay out of the panel.
// backend/functions/songbuzz.ts creates and writes it.
const catalogueFilesCollection = defineCollection({
    name: "Catalogue files",
    singularName: "Catalogue file",
    slug: "catalogue_files",
    table: "songbuzz_catalogue_files",
    description: "The catalogue as files games load (songs.json, one per mix and country), and which build made them.",
    securityRules: [{ operation: "select", roles: ["admin"] }],
    properties: {
        path: { name: "File", type: "string", isId: "manual", admin: { readOnly: true } },
        build: { name: "Built", description: "When the catalogue-files cron made it", type: "string", validation: { required: true }, admin: { readOnly: true } },
        etag: { name: "Version", type: "string", validation: { required: true }, admin: { readOnly: true, hideFromCollection: true } },
        body: { name: "Contents", type: "binary", validation: { required: true }, excludeFromApi: true, admin: { hideFromCollection: true, disabled: { hidden: true } } },
    },
    admin: {
        icon: "FileArchive",
        group: "System",
        openEntityMode: "side_panel",
        sort: ["path", "asc"],
        // what's in it ("world/lang_3apt.json" is the songs sung in Portuguese, worldwide), then the file it is
        display: { title: ({ entity }) => catalogueFile(entity.values.path), subtitle: ({ entity }) => `${entity.values.path} · built ${entity.values.build}` },
        listProperties: ["path", "build"],
    },
});

export default catalogueFilesCollection;
